// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@liveblocks/react-ui/styles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Adding imports for Liveblocks.io styles in .global.css file since currently webpack is not configured to read files from index.css */

.thread,
.composer {
  position: relative;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow:
    0 0 0 1px rgb(0 0 0 / 4%),
    0 2px 6px rgb(0 0 0 / 4%),
    0 8px 26px rgb(0 0 0 / 6%);
}

button.lb-button[aria-label='More'],
button.lb-button[aria-label='Add emoji'] {
  display: none !important;
}

.lb-tooltip {
  z-index: 10000 !important;
}
`, "",{"version":3,"sources":["webpack://./index.global.css"],"names":[],"mappings":"AAAA,uIAAuI;;AAIvI;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB;;;8BAG4B;AAC9B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Adding imports for Liveblocks.io styles in .global.css file since currently webpack is not configured to read files from index.css */\n\n@import '../node_modules/@liveblocks/react-ui/styles.css';\n\n.thread,\n.composer {\n  position: relative;\n  border-radius: 0.75rem;\n  overflow: hidden;\n  box-shadow:\n    0 0 0 1px rgb(0 0 0 / 4%),\n    0 2px 6px rgb(0 0 0 / 4%),\n    0 8px 26px rgb(0 0 0 / 6%);\n}\n\nbutton.lb-button[aria-label='More'],\nbutton.lb-button[aria-label='Add emoji'] {\n  display: none !important;\n}\n\n.lb-tooltip {\n  z-index: 10000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
